import React from 'react';
import './App.css';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { Solutions } from './components/Solutions';
import { About } from './components/About';
import { Products } from './components/Products';
import { Contact } from './components/Contact';
import { Footer } from './components/Footer';
import { BackgroundWaterEffects } from './components/animations/BackgroundWaterEffects';
import { CookieConsentBanner } from './components/CookieConsentBanner';
import { useConsent } from './hooks/useConsent';

function App() {
  const { updateConsent } = useConsent();

  return (
    <div className="App">
      <BackgroundWaterEffects />
      <Header />
      <Hero />
      <Solutions />
      <About />
      <Products />
      <Contact />
      <Footer />
      <CookieConsentBanner onConsentChange={updateConsent} />
    </div>
  );
}

export default App;
